<template>
	<component :is="CTASize"
		:class="`btn btn-${color}`"
		:content="content"
		:isArrow="isArrow"
		:isArrowLeft="isArrowLeft"
		:isArrowDown="isArrowDown"
		:isStar="isStar"
		:isArrowUp="isArrowUp"
		:disabled="!isDisabled && (disabled  || loading)"
		:loading="loading"
		:isWithLoader="isWidthLoader"
		:isDisabled="isDisabled"
		@click="$emit('click', $event)"
		class="icon"
	/>
</template>

<script type="text/javascript">

import CTABig from './CTABig'
import CTASmall from './CTASmall'

export default {
	data () {
		return {
			
		}
	},

	computed: {
		CTASize () {
			if (this.size === 'big') return 'CTABig'
			if (this.size === 'small') return 'CTASmall'
		}
	},

	components: {
		CTASmall,
		CTABig
	},

	props: {
		isWidthLoader: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false
		},
		content: {
			type: String,
			default: null
		},
		isArrow: {
			type: Boolean,
			default: false
		},
		isArrowLeft: {
			type: Boolean,
			default: false
		},
		isArrowDown: {
			type: Boolean,
			default: false
		},
		isArrowUp: {
			type: Boolean,
			default: false
		},
		isStar: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'big'
		},
		color: {
			type: String,
			default: 'green'
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>

.btn,
.btn:focus,
.btn:active,
.btn:visited,
.btn:hover {
	text-transform: initial;
	border-radius: 4px;
	font-weight: 700;
	cursor: pointer;
	font-weight: bold;
	color: white;
	outline: none;
	box-shadow: none;
}

.btn a {
    text-decoration: none !important;
    color: white;
}

.btn-light {
    background-color: #ededed;
    color: #575A5C;
}

.btn-green {
    background-color: var(--quomi-primary);
}


.btn-gold {
    background-color: #E5C100;
}

.btn-green:hover,
.btn-green:focus,
.btn-green:active {
    background-color: var(--quomi-primary-hover);
}

.btn-dark {
    background: #575A5C;
    border-color: #575A5C;
}

.btn-grey {
	background-color: var(--quomi-darkgrey);
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active {
    background-color: #4b4d4f;
    border-color: #4b4d4f;
}


.btn-danger {
    background: var(--quomi-red);
    border-color: var(--quomi-red);
}

.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active {
	background: var(--quomi-red-hover);
    border-color: var(--quomi-red-hover);
}

.btn-orange {
    background: var(--quomi-orange);
    border-color: var(--quomi-orange);
}

.btn-blue{
    background:#3D65BB;
}

.btn-blue:hover{
    background: #5175C1;
}

.btn-transparent,
.btn-transparent:hover,
.btn-transparent:active,
.btn-transparent:focus {
	border: none;
	/*background-color: white;*/
	color: var(--quomi-darkgrey);
	font-weight: normal;
}

.btn-medium {
    font-size:15px;
    padding:7px;
}

.btn[disabled],
.btn.disabled {
    opacity: 0.5;
    cursor: default;
}


.icon::after {
	font-family: 'Font Awesome 5 Free';
	font-weight: 900; 
	padding-left: 10px;
}

.icon::before {
	font-family: 'Font Awesome 5 Free';
	font-weight: 900; 
	padding-right: 10px;
}

.star::before {
	content: "\f005";
}

.chevron-right::after {
	content: "\f054"; 	
}

.chevron-left::before {
	content: "\f053";
}

.chevron-up::after {
	content: "\f077";
}

.chevron-down::after {
	content: "\f078";
}
</style>